import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchUniswapPair(token1, token2, network) {
    return fetch(`${API_URL}/api/uniswapv2_pair?token1=${token1}&token2=${token2}&network=${network}`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
